<div class="widget-container">
  <button class="close-button" (click)="activeModal.close(accountSelected)">
    <rkt-icon name="times"></rkt-icon>
  </button>

  <app-loading-screen [hidden]="!loading" [loadingMessage]="loadingMessage"></app-loading-screen>

  <div id="iframe" class="iframe-container" [hidden]="loading">
    <iframe [src]="connectionURL | safe"></iframe>
  </div>
</div>
